import { Timestamp, addDoc, collection } from "firebase/firestore";
import { db } from "../firebase/config";
import { getDealershipByEmail } from "../data/dealerships";
import { submitLeadEmail } from "./leadEmail";

function getName(formData) {
  return formData.name ?? formData.userName ?? "";
}

export async function submitLegacyLead({
  collectionName,
  formData,
  firestoreData,
  leadPayload,
}) {
  await addDoc(collection(db, collectionName), {
    ...firestoreData,
    date: Timestamp.fromDate(new Date()),
  });

  const dealershipEmail = formData.dealership ?? "";
  const selectedDealership = getDealershipByEmail(dealershipEmail);

  await submitLeadEmail({
    ...leadPayload,
    customer: {
      name: getName(formData),
      email: formData.email ?? "",
      phone: formData.phone ?? "",
    },
    dealership: {
      email: dealershipEmail,
      label: selectedDealership?.label ?? dealershipEmail,
    },
    source: {
      pageUrl: window.location.href,
    },
  });
}
